import React, { useEffect, useState } from "react"
import { observer } from "mobx-react-lite"
import { IMG } from "./common/CONST"
import { Link, useNavigate } from "react-router-dom"
import { useStore } from "../stores/RootStoreContext"
import { ISigninRequest } from "../types/ISigninRequest"
import * as TrinityAPI from "../requests/TrinityAPI"
import { IErrorModel } from "../types/error/IErrorModel"
import { DASHBOARD_ROUTE, FORGOT_ROUTE } from "../routes"
import Button from "@/ui/components/Button"

export const SignIn = observer(() => {
  const { userStore } = useStore()
  const navigate = useNavigate()

  const [signinRequest, setSignInRequest] = useState<ISigninRequest>()
  const [errorModel, setErrorModel] = useState<IErrorModel>()
  const [isLoading, setLoading] = useState(false)

  useEffect(() => {
    if (userStore.getToken) {
      window.location.href = "/dashboard"
    }
  }, [])

  const submit = () => {
    if (!signinRequest) return

    setErrorModel(undefined)
    setLoading(true)

    TrinityAPI.signIn(
      signinRequest,
      response => {
        if (response.status === 200) {
          userStore.setToken(response.data.token)
          navigate(DASHBOARD_ROUTE)
        } else {
          setErrorModel(response.data)
        }
      },
      () => setLoading(false)
    )
  }

  const handleKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === "Enter") {
      submit()
    }
  }

  return (
    <div className="registration-container">
      <div className="reg-left-img-block">
        <img src={IMG.main_logo} alt="" className="img-main-enter" />
      </div>
      <div className="reg-right-block">
        <div className="block-form">
          <h2 className="heading-form">Вход</h2>
          <fieldset>
            <legend>E-mail</legend>
            <input
              type="email"
              required
              className="input-form"
              placeholder="example@example.com"
              onKeyDown={handleKeyDown}
              onChange={e => setSignInRequest({ ...signinRequest, username: e.target.value })}
            />
          </fieldset>
          <fieldset>
            <legend>Пароль</legend>
            <input
              type="password"
              required
              className="input-form"
              placeholder="A—a Z—z 1 * / -"
              onKeyDown={handleKeyDown}
              onChange={e => setSignInRequest({ ...signinRequest, password: e.target.value })}
            />
            {errorModel?.message ? <p className="error-form">{errorModel.message}</p> : <></>}
          </fieldset>
          <Link to={FORGOT_ROUTE} className="red-link fontsize-16">
            Не помню пароль
          </Link>
          <div className="flex-btn-justify">
            <Button loading={isLoading} onClick={submit}>
              Войти
            </Button>
            <Button onClick={() => navigate("/signup")} variant="white">
              Регистрация
            </Button>
          </div>
        </div>
      </div>
    </div>
  )
})
